module.exports = __webpack_public_path__ + "img/grupo-globo.1d26f8b5.svg";